import { Option } from '../../../components/Form/Inputs/AutocompleteInput'
import { NotificationReason } from '../enums/NotificationReason';
import NotificationType from '../enums/NotificationType';

type Settings = {
  defaultWorkingHours?: { start: string; end: string }
  hideSchedule: boolean
  remoteWorkMode: boolean
  defaultProject: Option | null
  workHourCollapseThreshold: number,
  workHoursSortByFavorite: boolean,
  notificationType: NotificationType
  mutedNotificationReasons: NotificationReason[]
}

export const defaultEmployeeSettings: Settings = {
  defaultProject: null,
  hideSchedule: false,
  remoteWorkMode: false,
  workHourCollapseThreshold: 1,
  defaultWorkingHours: { start: '08:00', end: '16:00' },
  workHoursSortByFavorite: false,
  notificationType: NotificationType.PUSH,
  mutedNotificationReasons: [
    NotificationReason.EMPLOYEE_VACATION_CREATED, 
    NotificationReason.EMPLOYEE_UPCOMING_VACATION,
    NotificationReason.NEW_CANDIDATE_COMMENT,
  ]
}

export default Settings
